export const SUPPORTED_LANGUAGES = [
  { key: 'ko', label: '🇰🇷 한국어' },
  { key: 'en', label: '🇺🇸 English' },
  { key: 'vi', label: '🇻🇳 Tiếng Việt' },
  { key: 'ru', label: '🇷🇺 Русский' },
];

// Claude API로 자동 번역 (Vercel Edge 프록시 경유 — JWT 필수)
export const autoTranslate = async ({ text, sourceLang = 'ko', targetLangs = ['en', 'vi', 'ru'] }) => {
  if (!text?.trim()) return {};

  try {
    const { getSupabase, isSupabaseConfigured } = await import('../lib/supabase');
    if (!isSupabaseConfigured) return {};
    const sb = getSupabase();
    if (!sb) return {};
    const {
      data: { session },
    } = await sb.auth.getSession();
    if (!session?.access_token) return {};

    const PROXY_URL =
      process.env.NODE_ENV === 'development' ? 'http://localhost:3000/api/translate' : '/api/translate';

    const response = await fetch(PROXY_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${session.access_token}`,
      },
      body: JSON.stringify({
        model: 'claude-sonnet-4-20250514',
        max_tokens: 1000,
        messages: [
          {
            role: 'user',
            content: `다음 텍스트를 ${targetLangs.join(', ')} 언어로 번역해줘.
원문 언어: ${sourceLang}
원문: "${text}"

반드시 아래 JSON 형식으로만 응답해. 다른 텍스트 없이:
{
  "en": "영어 번역",
  "vi": "베트남어 번역",
  "ru": "러시아어 번역"
}

교민 커뮤니티 앱의 콘텐츠이므로
자연스럽고 친근한 표현으로 번역해줘.`,
          },
        ],
      }),
    });

    const data = await response.json();
    const text_content = data.content?.find((c) => c.type === 'text')?.text;

    if (!text_content) return {};

    const clean = text_content.replace(/```json|```/g, '').trim();

    return JSON.parse(clean);
  } catch {
    return {};
  }
};

// 스토리 번역 저장
export const saveStoryTranslations = async (storyId, { titleTranslations, captionTranslations, sourceLang }) => {
  const { getSupabase, isSupabaseConfigured } = await import('../lib/supabase');
  if (!isSupabaseConfigured) return false;
  const sb = getSupabase();
  if (!sb) return false;
  const { error } = await sb
    .from('mingo_stories')
    .update({
      title_translations: titleTranslations,
      caption_translations: captionTranslations,
      source_language: sourceLang,
    })
    .eq('id', storyId);
  return !error;
};

// 시리즈 번역 저장
export const saveSeriesTranslations = async (seriesId, { titleTranslations, descriptionTranslations, sourceLang }) => {
  const { getSupabase, isSupabaseConfigured } = await import('../lib/supabase');
  if (!isSupabaseConfigured) return false;
  const sb = getSupabase();
  if (!sb) return false;
  const { error } = await sb
    .from('story_series')
    .update({
      title_translations: titleTranslations,
      description_translations: descriptionTranslations,
      source_language: sourceLang,
    })
    .eq('id', seriesId);
  return !error;
};

// 유저 언어에 맞는 텍스트 반환
export const getLocalizedText = (translations, fallback, language) => {
  if (!translations) return fallback;
  const lang = String(language || '').trim().slice(0, 5) || 'ko';
  return translations[lang] ?? translations.en ?? translations['en'] ?? fallback;
};
